<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div v-if="!isLensOrder">
        <!-- nothing -->
    </div>

    <div
        v-else-if="!canReorder"
        v-tippy="{ arrow: true, theme: 'sl-light', animation : 'fade' }"
        class="lsn-table-btn__wrapper lsn-table-btn__wrapper--disabled"
        :content="$t('orders.reorder_btn.not_allowed.help')"
        @click.stop
    >
        <mdi-icon class="lsn-table-btn" icon="mdiRepeat" />
    </div>

    <div
        v-else-if="!row.is_reorder_added"
        v-tippy="{ arrow: true, theme: 'sl-light', animation : 'fade' }"
        class="lsn-table-btn__wrapper text-primary-400"
        :content="$t('orders.reorder_btn.label')"
        @click.stop="toggleReOrder()"
    >
        <mdi-icon class="lsn-table-btn" icon="mdiRepeat" />
    </div>

    <div
        v-else
        class="lsn-table-btn__wrapper text-yellow-500"
        @click.stop="toggleReOrder()"
    >
        <mdi-icon class="lsn-table-btn" icon="mdiCheck" />
    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReOrderCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },

    emits: ['remove-from-reorder', 'add-to-reorder'],

    computed:
    {
        isLensOrder()
        {
            return this.row.order_class === 'App\\Orders\\Orders\\LensOrder';
        },

        canReorder()
        {
            const prototype = this.$store.state.prototypes.prototypes.find(
                p => p.code === this.row.article_data.PROTOTYPE_CODE
            );
            if(!prototype)
            {
                return false;
            }

            return prototype?.status !== this.$const.articles.status.INACTIVE;
        },
    },

    methods:
    {
        toggleReOrder()
        {
            if(this.row.is_reorder_added)
            {
                this.$emit('remove-from-reorder', this.row);
            }
            else
            {
                this.$emit('add-to-reorder', this.row);
            }
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style scoped>
@reference "#main.css";


.lsn-table-btn__wrapper
{
    height: 34px;
    width: 34px;
    margin-left: 10px;
    @apply flex items-center justify-center border border-primary-100 rounded-full cursor-pointer;
}

.lsn-table-btn__wrapper:hover
{
    @apply bg-primary-200;
}

.lsn-table-btn__wrapper--disabled
{
    @apply cursor-not-allowed border-gray-300 text-gray-300 hover:bg-transparent;
}

.lsn-table-btn
{
    width: 20px;
    height: 20px;
}

</style>
